"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@apollo/client/core");
var badge = {
    BADGE: core_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment Badge on Badge {\n      image\n      label\n    }\n  "], ["\n    fragment Badge on Badge {\n      image\n      label\n    }\n  "]))),
};
exports.default = badge;
var templateObject_1;
